// extracted by mini-css-extract-plugin
module.exports = {"total":"ClansRatingSearchResult_total_1aj02","totalValue":"ClansRatingSearchResult_totalValue_2IRtH","spinner":"ClansRatingSearchResult_spinner_3uCaz"};